module.exports = __webpack_public_path__ + "img/qy.e26ea82a.png";